import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "payments-block__middle replenishment-type" }
const _hoisted_2 = {
  key: 0,
  class: "acquiring-payment__card-form"
}
const _hoisted_3 = { class: "acquiring-payment__title" }
const _hoisted_4 = { class: "acquiring-payment__field" }
const _hoisted_5 = { class: "acquiring-payment__label" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "acquiring-payment__error"
}
const _hoisted_8 = { class: "acquiring-payment__row" }
const _hoisted_9 = { class: "acquiring-payment__field acquiring-payment__field--half" }
const _hoisted_10 = { class: "acquiring-payment__label" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "acquiring-payment__error"
}
const _hoisted_13 = { class: "acquiring-payment__field acquiring-payment__field--half" }
const _hoisted_14 = { class: "acquiring-payment__label" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "acquiring-payment__error"
}
const _hoisted_17 = { class: "acquiring-payment__field" }
const _hoisted_18 = { class: "acquiring-payment__label" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "acquiring-payment__error"
}
const _hoisted_21 = { class: "acquiring-payment__field" }
const _hoisted_22 = { class: "acquiring-payment__label" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "acquiring-payment__error"
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "acquiring-payment__error acquiring-payment__error--general"
}
const _hoisted_27 = {
  key: 1,
  class: "acquiring-payment__processing"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "acquiring-payment__title" }
const _hoisted_30 = { class: "acquiring-payment__description" }
const _hoisted_31 = {
  key: 1,
  class: "acquiring-payment__error acquiring-payment__error--general"
}
const _hoisted_32 = {
  key: 2,
  class: "acquiring-payment__3ds-form"
}
const _hoisted_33 = { class: "replenishment-type__bank" }
const _hoisted_34 = { class: "acquiring-payment__description" }
const _hoisted_35 = { class: "acquiring-payment__field" }
const _hoisted_36 = { class: "acquiring-payment__label" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = {
  key: 0,
  class: "acquiring-payment__error"
}
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "acquiring-payment__error acquiring-payment__error--general"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showCardForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('invoice.acquiring.card-form-title')), 1),
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCardSubmit && _ctx.handleCardSubmit(...args)), ["prevent"])),
            class: "acquiring-payment__form"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('invoice.acquiring.card-number')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cardForm.cardNumber) = $event)),
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.formatCardNumber && _ctx.formatCardNumber(...args))),
                type: "text",
                class: "acquiring-payment__input",
                placeholder: _ctx.$t('invoice.acquiring.card-number-placeholder'),
                maxlength: "19",
                required: ""
              }, null, 40, _hoisted_6), [
                [_vModelText, _ctx.cardForm.cardNumber]
              ]),
              (_ctx.errors.cardNumber)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.errors.cardNumber), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('invoice.acquiring.expiry-month')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cardForm.expiryMonth) = $event)),
                  type: "text",
                  class: "acquiring-payment__input",
                  placeholder: _ctx.$t('invoice.acquiring.expiry-month-placeholder'),
                  maxlength: "2",
                  required: ""
                }, null, 8, _hoisted_11), [
                  [_vModelText, _ctx.cardForm.expiryMonth]
                ]),
                (_ctx.errors.expiryMonth)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.errors.expiryMonth), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('invoice.acquiring.expiry-year')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cardForm.expiryYear) = $event)),
                  type: "text",
                  class: "acquiring-payment__input",
                  placeholder: _ctx.$t('invoice.acquiring.expiry-year-placeholder'),
                  maxlength: "4",
                  required: ""
                }, null, 8, _hoisted_15), [
                  [_vModelText, _ctx.cardForm.expiryYear]
                ]),
                (_ctx.errors.expiryYear)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.errors.expiryYear), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('invoice.acquiring.cardholder-name')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cardForm.cardholderName) = $event)),
                onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.formatCardholderName && _ctx.formatCardholderName(...args))),
                type: "text",
                class: "acquiring-payment__input",
                placeholder: _ctx.$t('invoice.acquiring.cardholder-name-placeholder'),
                required: ""
              }, null, 40, _hoisted_19), [
                [_vModelText, _ctx.cardForm.cardholderName]
              ]),
              (_ctx.errors.cardholderName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.errors.cardholderName), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('invoice.acquiring.cvv')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cardForm.cvv) = $event)),
                type: "text",
                class: "acquiring-payment__input",
                placeholder: _ctx.$t('invoice.acquiring.cvv-placeholder'),
                maxlength: "4",
                required: ""
              }, null, 8, _hoisted_23), [
                [_vModelText, _ctx.cardForm.cvv]
              ]),
              (_ctx.errors.cvv)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.errors.cvv), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn--accept acquiring-payment__submit",
              disabled: _ctx.isLoading
            }, _toDisplayString(_ctx.isLoading ? _ctx.$t('invoice.acquiring.processing') : _ctx.$t('invoice.acquiring.pay-button')), 9, _hoisted_25),
            (_ctx.submitError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.submitError), 1))
              : _createCommentVNode("", true)
          ], 32)
        ]))
      : (_ctx.isRedirectProcessing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            (!_ctx.submitError)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("img", {
                    class: "acquiring-payment__spinner",
                    src: require('@/assets/img/90-ring-with-bg.svg'),
                    alt: ""
                  }, null, 8, _hoisted_28),
                  _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.$t('invoice.acquiring.processing-title')), 1),
                  _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('invoice.acquiring.processing-hint')), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.submitError), 1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('invoice.acquiring.3ds-form-title')), 1),
            _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('invoice.acquiring.3ds-description')), 1),
            _createElementVNode("form", {
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handle3dsSubmit && _ctx.handle3dsSubmit(...args)), ["prevent"])),
              class: "acquiring-payment__form"
            }, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('invoice.acquiring.3ds-code')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.threeDsCode) = $event)),
                  type: "text",
                  class: "acquiring-payment__input",
                  placeholder: _ctx.$t('invoice.acquiring.3ds-code-placeholder'),
                  maxlength: "10",
                  required: ""
                }, null, 8, _hoisted_37), [
                  [_vModelText, _ctx.threeDsCode]
                ]),
                (_ctx.errors.threeDsCode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.errors.threeDsCode), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn--accept acquiring-payment__submit",
                disabled: _ctx.isLoading
              }, _toDisplayString(_ctx.isLoading ? _ctx.$t('invoice.acquiring.processing') : _ctx.$t('invoice.acquiring.submit-3ds')), 9, _hoisted_39),
              (_ctx.submitError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.submitError), 1))
                : _createCommentVNode("", true)
            ], 32)
          ]))
  ]))
}